import api from './api';

// The mentor's own availability tab. Every endpoint is scoped server-side to the logged-in
// mentor — no mentor id is ever sent, and the API would ignore one.
//
// The state object these all return carries `gateway`:
//   'internal'  the mentor has an @create-ed.in address: they can connect their Google calendar,
//               and a booked session is written onto it directly.
//   'external'  any other address: slots live in COSMIC and SYNC schedules the meeting, so there
//               is no calendar to connect (calendar_supported is false).

export const getAvailability = async () => {
  const response = await api.get('/mentor-availability');
  return response.data;
};

// Replaces the entire weekly pattern. `rules` is every window for the week:
// [{ day_of_week: 0..6 (0 = Sunday), start_time: 'HH:MM', end_time: 'HH:MM' }]
// An empty array removes all availability, which stops students booking.
export const saveRules = async ({ timezone, rules }) => {
  const response = await api.put('/mentor-availability/rules', { timezone, rules });
  return response.data;
};

// A day off: { specific_date, is_available: false }.
// Custom hours for one date: { specific_date, is_available: true, start_time, end_time }.
export const addOverride = async (override) => {
  const response = await api.post('/mentor-availability/overrides', override);
  return response.data;
};

export const deleteOverride = async (overrideId) => {
  const response = await api.delete(`/mentor-availability/overrides/${overrideId}`);
  return response.data;
};

export const connectCalendar = async () => {
  const response = await api.post('/mentor-availability/calendar/connect');
  return response.data;
};

export const disconnectCalendar = async () => {
  const response = await api.delete('/mentor-availability/calendar');
  return response.data;
};

export const getBookedSessions = async ({ includePast = false } = {}) => {
  const response = await api.get('/mentor-availability/sessions', {
    params: { include_past: includePast }
  });
  return response.data;
};

export const cancelBookedSession = async (sessionId, reason) => {
  const response = await api.post(`/mentor-availability/sessions/${sessionId}/cancel`, { reason });
  return response.data;
};
